import React from 'react'
import './aboutUs.css'
import INCSUBFooter from '../../components/Footer/Footer'
import INCSUBHeader from '../../components/header/header'
import INCSUBCommonHeading from '../../commonComponents/commonHeading/commonHeading'

function INCSUBAboutus() {
  return (
    <div className='INCSUBAboutus_body'>
      <div className="INCSUBHeader_ctn_about_content">
        <div className="INCSUBHeader_ctn_about_content_hold">
          {/* <INCSUBCommonHeading text={'About Us'} top={-30} left={54} /> */}
          <div className="INCSUBHeader_ctn_about_content_hold_para">
            {/* <div className='INCSUB_ourTeam_para_holder'>
              <p>At TheSubscription, we’re solving a real problem — helping students and young professionals manage digital subscriptions from one smart, affordable platform.
                No more juggling logins or losing track of bills, just organized, trust-based access to what you love.</p>
              <div className='INCSUB_ourTeam_actualpara_holder'>
              <h3>Our Team of Students</h3>
              <p>We’re a passionate crew of college students handling operations, planning, outreach, and coordination.
                From logistics to community growth, we keep the platform moving with heart and hustle.</p>
                </div>
            </div> */}
            <div className='INCSSUB_Builders_ctn'>
              <div className='INCSSUB_Builders_ctn_text INCSSUB_Builders_ctn_text_para_founder'>
                <h3>From the Founder</h3>
                <p>Hi, I’m <span style={{ color: '#fff', fontWeight: 600 }}>Ranjeet Bhosale,</span> Founder & CEO.<br></br>
                  As a student myself, I saw how difficult it is to manage multiple digital subscriptions — from streaming to productivity tools — especially when you’re on a budget. Most people either overspend or lose track of what they’re paying for.
                  <br></br>That’s why we created <span style={{ color: '#fff', fontWeight: 600 }}>TheSubscription</span > to help people <span style={{ color: '#fff', fontWeight: 600 }}>manage</span>  subscriptions, all from one place. Our goal is to build a
                  <span style={{ color: '#fff', fontWeight: 600 }}> trust-based, community-powered platform</span> <br></br>that makes subscription management smarter and more affordable.
                </p>
              </div>
              <div className='INCSSUB_funderHolder_left_ctn'>
                <div className='INCSSUB_CEO_ctn_img_holder'>
                  <img src='/assets/images/Founder_Img.png' alt='' />
                  <div className='INCSSUB_CEO_span_holder'>
                    <span className='FounderNameSpan'  >Ranjeet  Bhosale</span>
                    <span className='FounderPositionSpan'>Founder & CEO</span>
                  </div>
                </div>
              </div>
            </div>

            <div className='INCSSUB_funderHolder'>
              <div className='INCSSUB_Builders_ctn_img_holder'>
                <img src='/assets/images/superX.png' alt='' />
              </div>
              <div className='INCSSUB_Builders_ctn_text_superx INCSSUB_Builders_ctn_text_para'>
                <h3 style={{ color: '#fff' }}>Where It All Started — SuperX by Core2web</h3>
                <p>
                  The journey truly began at <span style={{ color: '#fff', fontWeight: 600 }}>SuperX by Core2web, </span>
                  where I first pitched the idea behind TheSubscription.
                </p>
                <p>
                  What started as a concept not only won the competition, but it also sparked a shared belief.<br></br>
                  <span style={{ color: '#fff', fontWeight: 600 }}>Shashi Sir</span> and the <span style={{ color: '#fff', fontWeight: 600 }}>Incubators team </span>
                  saw the potential and came on board as partners, helping turn that vision into a real, growing product.                </p>
              </div>
            </div>

            <div className='INCSSUB_Builders_ctn'>
              <div className='INCSSUB_Builders_ctn_text'>
                <h3>Powered by : Incubators Systems</h3>
                <p>Our technology partner, <span style={{ color: '#fff', fontWeight: 600 }}>Incubators by Core2web</span>,
                  powers the platform with <span style={{ color: '#fff', fontWeight: 600 }}>clean, scalable, and secure tech architecture.</span> From frontend design to backend infrastructure, the Incubators team ensures that every line of code aligns with performance, reliability, and user satisfaction.
                  They manage the <span style={{ color: '#fff', fontWeight: 600 }}>development and system performance</span> to keep things running at scale.
                  Their expertise transforms our vision into a real product — one that adapts, grows, and improves with each iteration. With Incubators by our side, we're not just launching an app — we're building a sustainable tech ecosystem for collaborative subscriptions.
                </p>
              </div>
              <div className='INCSSUB_Builders_ctn_img_holder'>
                <img src='/assets/images/INCSUB_Team_img.png' alt='' />
              </div>
            </div>


            <div className='INCSUB_Exprience'>
              <h3>Join the movement</h3>
              <h4>Stream Smarter.</h4>
              <h4>Manage Better.</h4>
              <p><span >Experience it The Subscription way.</span></p>
              <h4></h4>
              <h4></h4>
              <h4></h4>

            </div>
          </div>
        </div>
      </div>
      <INCSUBFooter />
    </div>
  )
}

export default INCSUBAboutus
